<template>
  <ModalContainer :show="show" @close="onCancel">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
    <template slot="header">
      <h4 class="mb-0">{{ $t("add-contact") }}</h4>
    </template>

    <template slot="body">
      <form class="p-2" @submit.prevent="addcontact">
        <div class="form-group">
          <label for="fullname"> {{ $t("receiver-name") }}</label>
          <input
            type="text"
            name="name"
            v-model="fullname"
            class="form-control"
            required
            id="receiver-name"
            :placeholder="$t('enter-name')"
            @keypress="isLetter($event)"
          />
        </div>

        <div class="form-group">
          <label for="fullname"> {{ $t("email") }}</label>
          <input
            v-model="email"
            type="text"
            name="name"
            class="form-control"
            required
            id="email"
            :placeholder="$t('enter-email')"
          />
        </div>

        <div class="form-group">
          <label for="InputNumber"> Phone Number </label>
          <input
            v-model="number"
            type="tel"
            class="form-control"
            required
            id="phone-number"
            :placeholder="$t('enter-number')"
          />
          <p v-if="ErrorPhone" class="my-0 small text-error p-1">
            {{ ErrorPhone }}
          </p>
        </div>

        <div class="form-group">
          <label for="fullname"> {{ $t("address") }} </label>
          <input
            v-model="address"
            type="text"
            name="name"
            class="form-control"
            required
            id="address"
            :placeholder="$t('enter-address')"
          />
        </div>

        <div type="submit" class="btn-add">
          <button>{{ $t("add") }}</button>
        </div>
      </form>
    </template>
  </ModalContainer>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ModalContainer from "../../components/ModalContainer";
import vClickOutside from "v-click-outside";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import * as intlTelInput from "../../assets/js/intlTelInput";
import * as utils from "../../assets/js/utils";

export default {
  name: "AddDispatchContact",
  components: {
    ModalContainer,
    Loading,
  },

  props: {
    show: Boolean,
    onCancel: Function,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      fullname: "",
      email: "",
      address: "",
      number: "",
      mssg: "",
      ErrorPhone: "",
      Errormssg: "",
      iti: "",
      selectNotification: "",
    };
  },
  mounted() {
    this.iti = intlTelInput(document.querySelector("#phone-number"), {
      separateDialCode: true,
      utilsScript: utils,
    });
  },
  computed: {
    ...mapGetters([]),
  },
  methods: {
    ...mapActions(["addContacts", "getContacts"]),
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[a-zA-Z\s\b]*$/.test(char)) return true;
      else e.preventDefault();
    },
    validatePhoneNumber() {
      this.ErrorPhone = "";
      if (this.iti.isValidNumber()) {
        return true;
      } else {
        this.ErrorPhone = this.$t("valid_phone");
        return false;
      }
    },
    addcontact() {
      console.log(this.fullname, this.email, this.number, this.address);
      if (!this.validatePhoneNumber(this.number)) {
        this.ErrorPhone = this.$t("valid_phone");
        return;
      }
      this.isLoading = true;
      const newContact = {
        name: this.fullname,
        address: this.address,
        email: this.email.toLowerCase(),
        phoneNumber: this.number,
      };
      this.addContacts(newContact)
        .then((res) => {
          this.getContacts();
          this.onCancel();
          this.isLoading = false;
          this.$emit("showSuccessPopup", {
            msg: this.$t("success_msg_contact"),
            heading: this.$t("success_heading_contact"),
          });
        })
        .catch((error) => {
          console.error("Error adding contact:", error);
          this.isLoading = false;
          this.Errormssg = "Error adding contact. Please try again.";
        });
    },
  },
};
</script>

<style>
label,
.form-control::placeholder {
  font-weight: 400;
  color: rgba(94, 106, 121, 1);
}

label {
  list-style: 15.6px;
  font-size: 12px;
}

.form-control::placeholder {
  font-size: 14px;
  line-height: 19.69px;
}

.btn-add {
  padding: 0;
  border-radius: 0;
  width: 100%;
  display: flex;
  justify-content: right;
}

.btn-add > button {
  border: none;
  border-radius: 16px;
  background-color: rgba(33, 62, 122, 1);
  color: rgba(247, 248, 249, 1);
  width: 84px;
  height: 44px;
  padding: 12px, 30px, 12px, 30px;
  font-size: 14px;
  font-weight: 600;
}
</style>

<i18n>
  {
    "en": {
      "add-contact": "Add Contact",
      "receiver-name": "Receiver's Name",
      "enter-name": "Enter Receiver's Name",
      "email": "Email Address",
      "enter-email": "Enter Email Address",
      "number": "Phone Number",
      "enter-number": "Enter Phone Number",
      "address": "Address",
      "enter-address": "Enter Address",
      "add": "Add",
		"valid_phone": "This phone number is not valid"

    },
    "es": {
    "add-contact": "Agregar contacto",
    "receiver-name": "Nombre del receptor",
    "enter-name": "Ingrese el nombre del receptor",
    "email": "Dirección de correo electrónico",
    "enter-email": "Ingrese la dirección de correo electrónico",
    "number": "Número de teléfono",
    "enter-number": "Ingrese el número de teléfono",
    "address": "Dirección",
    "enter-address": "Ingrese la dirección",
    "add": "Añadir"
    },
    "fr": {
      "add-contact": "Ajouter un contact",
    "receiver-name": "Nom du destinataire",
    "enter-name": "Entrez le nom du destinataire",
    "email": "Adresse e-mail",
    "enter-email": "Entrez l'adresse e-mail",
    "number": "Numéro de téléphone",
    "enter-number": "Entrez le numéro de téléphone",
    "address": "Adresse",
    "enter-address": "Entrez l'adresse",
    "add": "Ajouter"
    },
    "sw": {
      "add-contact": "Ongeza Mawasiliano",
    "receiver-name": "Jina la Mpokeaji",
    "enter-name": "Ingiza Jina la Mpokeaji",
    "email": "Barua pepe",
    "enter-email": "Ingiza Anwani ya Barua pepe",
    "number": "Namba ya Simu",
    "enter-number": "Ingiza Namba ya Simu",
    "address": "Anwani",
    "enter-address": "Ingiza Anwani",
    "add": "Ongeza"
    }
  }
  </i18n>
